export class AsyncArray {
  constructor(values) {
    this.values = values;
  }
  resolve () {
    return  Promise.resolve(this.values)
           .then(resolvedArray => Promise.all(
             resolvedArray.map(value => Promise.resolve(value))))
  }
  then (onResolve, onReject) {
    return this.resolve().then(onResolve, onReject);
  }

  catch (onReject) {
    this.resolve().catch(onReject);
  }
}
const ARRAY_RETURNING_METHODS = {
  concat: true,
  copyWithin: true,
  fill: true,
  filter: true,
  keys: true,
  map: true,
  reverse: true,
  slice: true,
  sort: true,
  splice: true,
  values: true
}

for (let methodName of Object.getOwnPropertyNames(Array.prototype)) {
  if (!AsyncArray.prototype.hasOwnProperty(methodName)
      && typeof Array.prototype[methodName] === 'function') {
    if (methodName in ARRAY_RETURNING_METHODS) {
      AsyncArray.prototype[methodName] = function (...args) {
        return new AsyncArray(this.resolve().then(
          resolvedValues => resolvedValues[methodName](...args)));
      }
    } else {
      AsyncArray.prototype[methodName] = function (...args) {
        return this.resolve().then(
          resolvedValues => resolvedValues[methodName](...args));
      }
    }
  }
}

export function asyncArray(array) {
  return new AsyncArray(array);
}

/**
 * String template tag that resolves its values before substitution.
 * @param  {string}    strings raw template string
 * @param  {Array(object|Promise)} values  substitution values
 * @return {Promise}
 */
export function asyncString(strings, ...values) {
  return asyncArray(values)
    .resolve()
    .then(resolvedValues => String.raw(strings, resolvedValues));
}

export class AsyncIterator {
  constructor () {
    this.lastIteration = null;
    this.cursor = 0;
    this.iteration = -1;
    this.values = [];
    this.lastValueProvidedIdx = -1;
    this.requestedValuePromises = [];
    this.iteratorResolved = false;
  }

  [Symbol.iterator] () {
    return this;
  }

  provideValue (value) {
    this.lastValueProvidedIdx++;
    if (value.then) {
      value.then(resolved => {
        this.values.push(resolved);
        this.tryResolveNext();
      }).catch(e=>{this.error(e)});
    } else {
      this.values.push(value);
      this.tryResolveNext();
    }
  }

  nextValuePromise () {
    return new Promise((resolve, reject) => {
      this.requestedValuePromises.push({
        resolve, reject
      });
      this.tryResolveNext();
    });
  }

  tryResolveNext () {
    if (!this.resolved && this.values.length > 0) {
      this.resolved = true;
      this.iteratorPromiseResolve(this);
    }
    let availableValues = this.values.length  - this.cursor;
    if (availableValues > 1
        || (this.lastIteration !== null
           && this.values.length - 1 === this.lastIteration
           && availableValues > 0) ) {
      this.sendNextValue();
    }
  }
  sendNextValue () {
    if (this.requestedValuePromises.length - 1 >= this.cursor) {
      this.requestedValuePromises[this.cursor].resolve(this.values[this.cursor]);
      this.cursor++;
    }

  }
  isDone () {
    return this.lastIteration !== null && this.iteration === this.lastIteration + 1;
  }
  next () {
    this.iteration++;
    if (this.isDone()) {
      return {done: true};
    } else {
      return {done: false, value: this.nextValuePromise()}
    }
  }

  finish () {
          this.lastIteration = this.lastValueProvidedIdx;
    if (!this.resolved && this.values.length === 0) {
      this.resolved = true;
      this.iteratorPromiseResolve(this);
    } else {
      this.tryResolveNext();
    }
  }

  error (e) {
    if (this.iteratorPromiseReject) {
      this.iteratorPromiseReject(e);
    }
    this.requestedValuePromises.map(p => p.reject(e));
    throw(e);
  }

  /**
   * Returns the promise for the iterator object itself.
   */
  iteratorPromise () {
    return new Promise((resolve, reject) => {
      this.iteratorPromiseResolve = resolve;
      this.iteratorPromiseReject = reject;
    });
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-utils/async.js